import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { RMLink, Text } from '../../../components';
import { RMCard } from '../RMCard';
import { LoadableValue, disabledWhileLoading, useCardLoadingState } from '../CardLoadingUtils';
import classNames from 'classnames';
import './SourcesCard.scss';

export const SourcesCard = ({ sources, headerAction, onClick, queryState }) => {
    const { loading, isError, disabled } = useCardLoadingState(queryState);
    const contentClassName = classNames('sources-card-content', { 'sources-card-content--clickable': !!onClick && !disabled });
    const headerActionLinkClassName = disabled ? 'link-disabled' : undefined;

    return (
        <RMCard className="sources-card" showMoreIcon={false} isError={isError}>
            <header>
                <div className="header-left">
                    <Text size="large" color="secondary">Sources</Text>
                    {headerAction && (
                        <RMLink
                            href={headerAction.href}
                            className={headerActionLinkClassName}
                        >
                            {headerAction.label} <RightOutlined />
                        </RMLink>
                    )}
                </div>
            </header>
            <div className={contentClassName} onClick={disabledWhileLoading(disabled, onClick)}>
                <Text size="extraLarge" xxlBold color="primaryBlue">
                    <LoadableValue isLoading={loading}>{sources}</LoadableValue>
                </Text>
            </div>
        </RMCard>
    );
};
